import {
    HIDE_MODAL,
    HIDE_NOT_LOGGED_MODAL,
    HIDE_REPORT,
    SHOW_MODAL,
    SHOW_NOT_LOGGED_MODAL,
    SHOW_SEND_GRADE_ERROR_MODAL,
    SHOW_REPORT,
    SHOW_THEORIES_MODAL,
    SHOW_OPEN_ASSIGNMENT_MODAL,
} from '../actions/modal';
import { GET_USER_INFO_MODAL } from '../containers/modal/modal-types';

const initialState = {
    notLoggedModalShowed: false,
    sendGradeErrorModalShowed: false,
    showReport: false,
    type: null,
    visible: false,
    theory: {
        theoryGroupId: null,
        theme: null,
        microtheme: null,
        theories: [],
    },
    assignmentUniqueCode: null,
};

export const reducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case SHOW_NOT_LOGGED_MODAL:
            return {
                ...state,
                notLoggedModalShowed: true,
            };
        case HIDE_NOT_LOGGED_MODAL:
            return {
                ...state,
                notLoggedModalShowed: true,
                visible: false,
                type: null,
            };
        case SHOW_MODAL:
            return {
                ...state,
                visible: true,
                type: action.payload,
            };
        case HIDE_MODAL:
            return {
                ...state,
                visible: false,
                type: null,
            };
        case SHOW_REPORT:
            return {
                ...state,
                showReport: true,
            };
        case HIDE_REPORT:
            return { ...state, showReport: false };
        case SHOW_SEND_GRADE_ERROR_MODAL:
            return {
                ...state,
                sendGradeErrorModalShowed: true,
            };
        case SHOW_THEORIES_MODAL: {
            return { ...state, theory: action.payload };
        }
        case SHOW_OPEN_ASSIGNMENT_MODAL:
            return {
                ...state,
                visible: true,
                type: GET_USER_INFO_MODAL,
                assignmentUniqueCode: action.payload,
            };
        default:
            return state;
    }
};
